/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Tag_SuccessInputs */



/**
* | output |
* | --- |
* | "Tag applied to {count} project(s)" |
*
* @param {Projects_Bulk_Tag_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_tag_success = /** @type {((inputs: Projects_Bulk_Tag_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Tag_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tag auf ${i?.count} Projekt(e) angewendet`)
	return /** @type {LocalizedString} */ (`Tag applied to ${i?.count} project(s)`)
});